import React from "react";

function article_1() {
	return {
		date: "Jul '23 to Jan '25",
		title: "Aeries Tecchnology",
		description:
			`One PE: Involved in Private Equity applications like Insights, and CADI. Data transformation from Excel to PostgreSQL DB through NodeJS API. 
			Mainly involved JavaScript functionality to transform data.
			Working around 120+ sources of news gathered for 3000+ companies from News API and CapIQ Data.
`,
		keywords: [
			"NewsAPI",
			"CapIQ",
			"Muthuraman",
			"VAP Student",
		],
		style: `
				.article-content {
					display: flex;
					flex-direction: column;
					align-items: center;
				}

				.randImage {
					align-self: center;
					outline: 2px solid red;
				}
				`,
		body: (
			<React.Fragment>
				<div className="article-content">
					<div className="paragraph">Project details</div>
					<img
						src="https://picsum.photos/200/300"
						alt="random"
						className="randImage"
					/>
				</div>
			</React.Fragment>
		),
	};
}

function article_2() {
	return {
		date: "Apr '21 to Jun '23",
		title: "Smartek21 India Private Ltd",
		description:
			`Health Care Interoperability: Involved in Healthcare sandbox systems like FHIR, and EPIC. 
			Data transformation from one format to another for example JSON to HL7, XML to JSON, and vice versa through NodeJS API, ECC API, and Mirth Connect. 
			Mainly involved JavaScript functionality to transform data`,
		style: ``,
		keywords: [
			"Health Care Interoperability",
			"Muthuraman",
			"VAP Student",
		],
		body: (
			<React.Fragment>
				<h1>Project details</h1>
			</React.Fragment>
		),
	};
}

function article_3() {
	return {
		date: "Apr '19 to Oct '20",
		title: "Cognitive Platform Solutions",
		description:
			`GCE Club: Created an online class application for the students of GCE Club Malaysia (more than 100 students in a class). 
			Used Jitsi Meet is an open-source video collaboration framework set up in a Linux server. 
			Front end UI created in MVC, JQuery, HTML & CSS. And MSSQL is the database `,
		style: ``,
		keywords: [
			"Online class GCE Club",
			"Muthuraman",
			"VAP Student",
		],
		body: (
			<React.Fragment>
				<h1>Project details</h1>
			</React.Fragment>
		),
	};
}

function article_4() {
	return {
		date: "Feb '18 to Mar '19",
		title: "Lookman Electroplast pvt ltd",
		description:
			`Smart City Application: This application is developed by using Angular 5 & 6 with MongoDB and MySQL 
			as a backend to maintain transaction and master data respectively. 
			API development in NodeJS & ExpressJS.`,
		style: ``,
		keywords: [
			"Smart City Application",
			"Muthuraman",
			"VAP Student",
		],
		body: (
			<React.Fragment>
				<h1>Project details</h1>
			</React.Fragment>
		),
	};
}

function article_5() {
	return {
		date: "Jul '17 to Jan '18",
		title: "Swot Technologies",
		description:
			`Worked as a technical lead & designing multiple projects (Inventory, Payroll, 
			Dealer Portal, Ad Agency Portal...) with SQL server 2016 as backend. 
			Handling projects in Angular 4 & 5 frameworks with API in NodeJS & ExpressJS.`,
		style: ``,
		keywords: [
			"Payroll",
			"Muthuraman",
			"VAP Student",
		],
		body: (
			<React.Fragment>
				<h1>Project details</h1>
			</React.Fragment>
		),
	};
}

function article_6() {
	return {
		date: "Apr '16 to Mar '17",
		title: "JKR Computers Services W.L.L (Kingdom of Bahrain)",
		description:
			`CRM PORTAL (Customer Relation Management): Developed web application CRM PORTAL using asp.net C#, SQL DB (Cloud Server) 
			and hosted in GODADDY server. www.jkrit.com/crm
			Scheduling Task for daily collection report as a mail to Admin via GODADDY server.
		`,
		style: ``,
		keywords: [
			"CRM PORTAL",
			"Muthuraman",
			"VAP Student",
		],
		body: (
			<React.Fragment>
				<h1>Project details</h1>
			</React.Fragment>
		),
	};
}
function article_7() {
	return {
		date: "Jan '14 to Mar '16",
		title: "Perigon InfoTech (P) Ltd",
		description:
			`Designed UX HTML and HTML5, asp.net C# and hosted to client’s server using ftp link or 
			Microsoft Azure server using web matrix tool with URL forwarding for clients.`,
		style: ``,
		keywords: [
			"C#",
			"Muthuraman",
			"VAP Student",
		],
		body: (
			<React.Fragment>
				<h1>Project details</h1>
			</React.Fragment>
		),
	};
}
function article_8() {
	return {
		date: "Jul '05 to Nov '13",
		title: "Verizon Data Services India (p) Ltd",
		description:
			`Template Report is the web application (ADO.Net, C#, SQL Server & DB2) dealing with metrics data. Installation and Maintenance of telephone lines are stored in mart table. 
			There are 400+ reports are there. Users can decide on ad-hoc reports also.`,
		style: ``,
		keywords: [
			"C#",
			"Muthuraman",
			"VAP Student",
		],
		body: (
			<React.Fragment>
				<h1>Project details</h1>
			</React.Fragment>
		),
	};
}
function article_9() {
	return {
		date: "Aug '03 to Jun '05",
		title: "Qatalys Software Technologies Ltd",
		description:
			`CARELynx - Dental Network Application for US healthCare                                                             
			A highly responsive web-enabled automated health management system to track Member, Provider, and complete record of a given transaction (medical) between provider and member.`,
		style: ``,
		keywords: [
			"CARELynx",
			"Muthuraman",
			"VAP Student",
		],
		body: (
			<React.Fragment>
				<h1>Project details</h1>
			</React.Fragment>
		),
	};
}
function article_0() {
	return {
		date: "Feb '25 to Oct '25",
		title: "NuSummit Technologies",
		description:
			`Gen AI with Full stack application (React, Angular, NodeJS with MYSQL, Mongo DB, PostgreSQL) in 
		Document Chat (Ollama Models) and Health Care application HL7, Mirth Connect, FHIR, EPIC`,
		style: ``,
		keywords: [
			"NuSummit",
			"Muthuraman",
			"VAP Student",
		],
		body: (
			<React.Fragment>
				<h1>Project details</h1>
			</React.Fragment>
		),
	};
}
const myArticles = [article_0, article_1, article_2, article_3, article_4, article_5, article_6, article_7, article_8, article_9];

export default myArticles;
